import { useState, useEffect } from "react";
import "./Imagecarousel.css";
import { images } from "../importImages";
import galleryData from "../galleryItems.json";

export default function Imagecarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLarge, setIsLarge] = useState(false);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + galleryData.length) % galleryData.length
    );
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        handlePrevious();
      } else if (event.key === "ArrowRight") {
        handleNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const currentItem = galleryData[currentIndex];

  return (
    <div className="carousel">
      <img
        className={`image-resize ${isLarge ? "large" : ""}`}
        key={currentItem}
        src={images[currentItem.image]}
        alt={currentItem}
        onClick={() => setIsLarge(!isLarge)}
      />
      <p className="p-carousel">{currentItem.text}</p>
      <div className="slide_direction">
        <div className="left" onClick={handlePrevious}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="40"
            viewBox="0 96 960 960"
            width="40"
          >
            <path d="M400 976 0 576l400-400 56 57-343 343 343 343-56 57Z" />
          </svg>
        </div>
        <div className="right" onClick={handleNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="40"
            viewBox="0 96 960 960"
            width="40"
          >
            <path d="m304 974-56-57 343-343-343-343 56-57 400 400-400 400Z" />
          </svg>
        </div>
        <div className="indicator">
          {galleryData.map((_, index) => (
            <div
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
}
